import { Link } from 'react-router-dom';
import type { NewsItem } from '@/mocks/news';

type NewsCardProps = {
  item: NewsItem;
  index?: number;
};

export default function NewsCard({ item, index = 0 }: NewsCardProps) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group animate-fade-up flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="aspect-[16/9] w-full overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 配图`}
          title={`${item.title} - 影视资讯`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex items-center gap-3 text-xs text-foreground-500">
          <span className="rounded-full bg-accent-100 px-2.5 py-0.5 font-medium text-accent-800">
            {item.category}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {item.date}
          </span>
        </div>
        <h3 className="mt-3 line-clamp-2 text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {item.summary}
        </p>
        <span className="mt-3 inline-flex items-center gap-1 pt-1 text-sm font-medium text-primary-600">
          阅读全文
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
        </span>
      </div>
    </Link>
  );
}